import { MenuType } from '@models/menu/menuType';
import { DataListType } from '@models/module/fields/main/dataListFieldModel';
import { MenuPermissionViewModel } from '@models/permission';

export interface MenuModel {
  id?: number;
  name: string;
  code?: RouteCodeEnum;
  iconId?: number;
  color?: string;
  position?: number;
  parentId?: number;
  typeId?: MenuType;
  moduleId?: number;
  perContract?: boolean;
  url?: string;
  email?: string;
  manageWorkflowGroups?: boolean;
  children?: MenuModel[];
  operations?: MenuPermissionViewModel[];
  openInNewTab?: boolean;
  hidden?: boolean;
  showOnDashboard?: boolean;
  useDocMinor?: boolean;
  moduleType?: MenuModuleTypeEnum;
  moduleTypeId?: number;
  urlPath?: string;
  workflowId?: number;
  workflowGroupId?: number;
  defaultWorkflowGroupId?: number;
  canOpenSettings?: boolean;
  defaultDataListType?: DataListType;
  extraPermissions?: boolean;
}

export interface MenuItem extends MenuModel {
  active?: boolean;
  parent?: MenuItem;
  level?: number;
}

export enum RouteCodeEnum {
  CompanyProfile = 'CP',
  Contacts = 'CTA',
  Contracts = 'CT',
  Correspondence = 'C',
  Dashboard = 'D',
  Entity = 'E',
  FileContractManager = 'FCM',
  FinancialSchedules = 'FSCH',
  Holidays = 'HLD',
  ListsManagement = 'LSTM',
  ManagementReports = 'MREP',
  Maps = 'MAPS',
  Menu = 'MN',
  Modules = 'M',
  MyCIPODrive = 'MCD',
  Organizations = 'O',
  Payments = 'PY',
  PDFMarkup = 'PDFM',
  PowerBI = 'PBI',
  ProgressPayment = 'PP',
  Roles = 'R',
  Schedules = 'SCH',
  SmartMap = 'SM',
  SOV = 'SOV',
  TenantSettings = 'TST',
  Users = 'U',
  //   these are dm modules, that should be converted to static pages
  ChangeOrder = 'CO',
  Programs = 'PRG',
  Projects = 'P',
  SysAdmin = 'SYS',
}

export enum MenuModuleTypeEnum {
  System = 1,
  URL = 2,
  Custom = 3,
  Internal = 4,
  Table = 5,
  Reporting = 6,
}
